/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ModuleType } from './ModuleType';
import {
    ModuleTypeFromJSON,
    ModuleTypeFromJSONTyped,
    ModuleTypeToJSON,
} from './ModuleType';
import type { TimeTable } from './TimeTable';
import {
    TimeTableFromJSON,
    TimeTableFromJSONTyped,
    TimeTableToJSON,
} from './TimeTable';

/**
 * 
 * @export
 * @interface ModuleFormAnswer
 */
export interface ModuleFormAnswer {
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    questionId?: string;
    /**
     * 
     * @type {ModuleType}
     * @memberof ModuleFormAnswer
     */
    type?: ModuleType;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    checkboxText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleFormAnswer
     */
    checkboxValue?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    textareaTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    lineTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    firstTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    secondTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    firstText?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    secondText?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    textareaText?: string;
    /**
     * 
     * @type {number}
     * @memberof ModuleFormAnswer
     */
    formId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ModuleFormAnswer
     */
    changed?: Date;
    /**
     * 
     * @type {number}
     * @memberof ModuleFormAnswer
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof ModuleFormAnswer
     */
    valueHigh?: number;
    /**
     * 
     * @type {number}
     * @memberof ModuleFormAnswer
     */
    valueLow?: number;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof ModuleFormAnswer
     */
    answer?: number;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    statementHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleFormAnswer
     */
    responseHeader?: string;
    /**
     * 
     * @type {TimeTable}
     * @memberof ModuleFormAnswer
     */
    timeTable?: TimeTable;
}

/**
 * Check if a given object implements the ModuleFormAnswer interface.
 */
export function instanceOfModuleFormAnswer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ModuleFormAnswerFromJSON(json: any): ModuleFormAnswer {
    return ModuleFormAnswerFromJSONTyped(json, false);
}

export function ModuleFormAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleFormAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questionId': !exists(json, 'QuestionId') ? undefined : json['QuestionId'],
        'type': !exists(json, 'Type') ? undefined : ModuleTypeFromJSON(json['Type']),
        'question': !exists(json, 'Question') ? undefined : json['Question'],
        'checkboxText': !exists(json, 'CheckboxText') ? undefined : json['CheckboxText'],
        'checkboxValue': !exists(json, 'CheckboxValue') ? undefined : json['CheckboxValue'],
        'textareaTitle': !exists(json, 'TextareaTitle') ? undefined : json['TextareaTitle'],
        'lineTitle': !exists(json, 'LineTitle') ? undefined : json['LineTitle'],
        'firstTitle': !exists(json, 'FirstTitle') ? undefined : json['FirstTitle'],
        'secondTitle': !exists(json, 'SecondTitle') ? undefined : json['SecondTitle'],
        'firstText': !exists(json, 'FirstText') ? undefined : json['FirstText'],
        'secondText': !exists(json, 'SecondText') ? undefined : json['SecondText'],
        'textareaText': !exists(json, 'TextareaText') ? undefined : json['TextareaText'],
        'formId': !exists(json, 'FormId') ? undefined : json['FormId'],
        'changed': !exists(json, 'Changed') ? undefined : (new Date(json['Changed'])),
        'value': !exists(json, 'Value') ? undefined : json['Value'],
        'valueHigh': !exists(json, 'ValueHigh') ? undefined : json['ValueHigh'],
        'valueLow': !exists(json, 'ValueLow') ? undefined : json['ValueLow'],
        'category': !exists(json, 'Category') ? undefined : json['Category'],
        'answer': !exists(json, 'Answer') ? undefined : json['Answer'],
        'statementHeader': !exists(json, 'StatementHeader') ? undefined : json['StatementHeader'],
        'responseHeader': !exists(json, 'ResponseHeader') ? undefined : json['ResponseHeader'],
        'timeTable': !exists(json, 'TimeTable') ? undefined : TimeTableFromJSON(json['TimeTable']),
    };
}

export function ModuleFormAnswerToJSON(value?: ModuleFormAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'QuestionId': value.questionId,
        'Type': ModuleTypeToJSON(value.type),
        'Question': value.question,
        'CheckboxText': value.checkboxText,
        'CheckboxValue': value.checkboxValue,
        'TextareaTitle': value.textareaTitle,
        'LineTitle': value.lineTitle,
        'FirstTitle': value.firstTitle,
        'SecondTitle': value.secondTitle,
        'FirstText': value.firstText,
        'SecondText': value.secondText,
        'TextareaText': value.textareaText,
        'FormId': value.formId,
        'Changed': value.changed === undefined ? undefined : (value.changed.toISOString()),
        'Value': value.value,
        'ValueHigh': value.valueHigh,
        'ValueLow': value.valueLow,
        'Category': value.category,
        'Answer': value.answer,
        'StatementHeader': value.statementHeader,
        'ResponseHeader': value.responseHeader,
        'TimeTable': TimeTableToJSON(value.timeTable),
    };
}

